import axios from 'axios'
import store from '@/store/store'

const timeout = 10000

const axiosHttp = axios.create()

const http = {
  /**
   * GET
   * @param {string} url 请求地址
   * @param {object} data Params Object
   * @param  {...any} extend 附加配置选项
   */
  get: function (url, data = {}, extend) {
    return axiosHttp.get(`${url}`, {
      params: data,
      timeout: timeout,
      ...extend
    })
  },

  /**
   * POST
   * @param {string} url 请求地址
   * @param {object} data Request Body
   * @param  {...any} options 附加配置选项
   */
  post: function (url, data = {}, options) {
    return axiosHttp.post(url, {
      ...data
    }, {
      timeout: timeout,
      ...options
    })
  },

  /**
   * PUT
   * @param {string} url 请求地址
   * @param {object} data Request Body
   * @param  {...any} options 附加配置选项
   */
  put: function (url, data = {}, options) {
    return axiosHttp.put(url, {
      ...data
    }, {
      timeout: timeout,
      ...options
    })
  },

  /**
   * POST
   * @param {string} url 请求地址
   * @param  {...any} options 附加配置选项
   */
  delete: function (url, options) {
    return axiosHttp.delete(url, {
      timeout: timeout,
      ...options
    })
  },
}

// 拦截请求
axiosHttp.interceptors.request.use(
  config => {
    // 在发送请求之前执行...
    // 注入caller
    const caller = store.getters.ilistenCaller
    if (config.data) {
      config.data.caller = caller
    } else {
      config.params.caller = caller
    }
    return config
  },
  error => {
    // 请求错误执行...
    console.log('req err: ', error) // for debug
    return Promise.reject(error)
  }
)

// 拦截响应
axiosHttp.interceptors.response.use(
  async res => {
    if (/tr\.idaddy\.cn\/trace/.test(res.request.responseURL)) return res.data
    if ((res.data && res.data.retcode) == 1) {
      return res.data
    }
    return Promise.reject(res.data)
  },
  error => {
    // console.log('res err: ', error)
    return Promise.reject(error)
  }
)

export default http
